import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { TimerProvider } from "@/context/TimerContext";
import { ThemeProvider } from "@/context/ThemeContext";
import Layout from "@/components/Layout";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import Jobs from "@/pages/Jobs";
import Agreements from "@/pages/Agreements";
import Timesheets from "@/pages/Timesheets";
import Schedule from "@/pages/Schedule";
import Invoices from "@/pages/Invoices";
import Forecaster from "@/pages/Forecaster";
import Settings from "@/pages/Settings";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="h-8 w-8 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const PublicOnly = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ThemeProvider>
          <TimerProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<PublicOnly><AuthPage /></PublicOnly>} />
              <Route
                path="/"
                element={
                  <Protected>
                    <Layout />
                  </Protected>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="clients" element={<Clients />} />
                <Route path="jobs" element={<Jobs />} />
                <Route path="agreements" element={<Agreements />} />
                <Route path="timesheets" element={<Timesheets />} />
                <Route path="schedule" element={<Schedule />} />
                <Route path="invoices" element={<Invoices />} />
                <Route path="forecast" element={<Forecaster />} />
                <Route path="settings" element={<Settings />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
          </TimerProvider>
        </ThemeProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
